module.exports = __webpack_public_path__ + "img/zabron.e6714dd3.png";